import { createApp } from 'vue'
import Bmi from './Bmi.vue'
import './assets/global.css'

createApp(Bmi).mount('#bmi')
